import React, { useEffect, useRef, useState } from "react";
import { Package, Upload, ArrowLeft, Save } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ProductVariantForm from "../ProductVariantForm";
import ShippingRatesManager from "../ShippingRatesManager";
import ProductImages from "../ProductImages";

const BackendUrl = process.env.REACT_APP_Backend_Url;
const admin = JSON.parse(localStorage.getItem("AdminEcomme"));

export default function UpdateProduct() {
  //const navigate = useNavigate();
  const params = useParams();
  const id = params.id;
  const [isLoading, setIsLoading] = useState(false);
  const [variants, setVariants] = useState([]);
  const [mainImages, setMainImages] = useState({
    image1: null,
    image2: null,
    image3: null,
  });
  const [currentImages, setCurrentImages] = useState({
    image1: "",
    image2: "",
    image3: "",
  });
  const [additionalImages, setAdditionalImages] = useState([]);
  const [ClefCategorie, setClefCategorie] = useState("");
  const [currentAdditionalImages, setCurrentAdditionalImages] = useState([]);
  const [imagesToDelete, setImagesToDelete] = useState([]); //1
  const [ClefType, setClefType] = useState("");
  const [Clefournisseur, setClefournisseur] = useState(null);
  if (admin) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${admin.token}`;
  }
  // États avec valeurs initiales
  const [zones, setZones] = useState([]);
  // État pour le formulaire d'ajout de transporteur
  const [nouveauTransporteur, setNouveauTransporteur] = useState({
    name: "",
    contact: "",
  });
  const [transporteurs, setTransporteurs] = useState([]);
  const [selectedOriginZone, setSelectedOriginZone] = useState("Europe");
  // État pour le formulaire d'ajout de zone
  const [nouvelleZone, setNouvelleZone] = useState({
    name: "",
    code: "",
    id: 1,
  });
  const [shippingOptions, setShippingOptions] = useState([]);
  const [packageDimensions, setPackageDimensions] = useState({
    weight: 0,
    length: 0,
    width: 0,
    height: 0,
  });
  const [productData, setProductData] = useState({
    name: "",
    description: "",
    price: "",
    pricePromo: "0",
    priceSuplier: 0,
    quantity: "",
    brand: "",
    supplier: "",
    type: "",
  });

  const [categories, setCategories] = useState([]);
  const [deletedVariantIds, setDeletedVariantIds] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const productImagesRef = useRef();

  const chgDeletedVariantIds = (id) => {
    setDeletedVariantIds([...deletedVariantIds, id]); // Crée un nouveau tableau
  };
  const handleAlert = (message) => {
    toast.success(`${message} !`);
  };

  const handleAlertwar = (message) => {
    toast.warn(`${message} !`);
  };
  const refreshProductData = () => {
    console.log("Rafraîchissement des données du produit...");
    // Logique pour rafraîchir les données après suppression
  };

  // Fonction pour extraire et filtrer les transporteurs uniques
  // Fonction de validation
  function validateTransporteurs(transporteurs) {
    if (!Array.isArray(transporteurs) || transporteurs.length === 0) {
      alert("Le tableau est vide ou invalide.");
      return false;
    }

    const requiredFields = [
      "baseFee",
      "name",
      "transporteurContact",
      "transporteurId",
      "transporteurName",
    ];

    for (let i = 0; i < transporteurs.length; i++) {
      const transporteur = transporteurs[i];

      // Vérification des champs requis
      for (const field of requiredFields) {
        if (!(field in transporteur)) {
          alert(`Champ manquant: ${field} à l'index ${i}`);
          return false;
        }
      }

      // Vérification des types de données
      if (
        typeof transporteur.name !== "string" ||
        transporteur.name.trim() === ""
      ) {
        alert(`Nom invalide à l'index ${i}.`);
        return false;
      }
      if (
        typeof transporteur.transporteurContact !== "string" ||
        !/^[0-9]{8}$/.test(transporteur.transporteurContact)
      ) {
        alert(`Contact du transporteur invalide à l'index ${i}.`);
        return false;
      }
      if (
        typeof transporteur.transporteurId !== "number" ||
        transporteur.transporteurId <= 0
      ) {
        alert(`ID du transporteur invalide à l'index ${i}.`);
        return false;
      }
      if (
        typeof transporteur.baseFee !== "number" ||
        transporteur.baseFee < 0
      ) {
        alert(`Frais de base invalide à l'index ${i}.`);
        return false;
      }
      if (
        typeof transporteur.transporteurName !== "string" ||
        transporteur.transporteurName.trim() === ""
      ) {
        alert(`Nom du transporteur invalide à l'index ${i}.`);
        return false;
      }
    }

    alert("Validation réussie.");
    return true;
  }

  // Fonction pour extraire et filtrer les transporteurs uniques
  function extractUniqueTransporteurs(transporteurs) {
    const uniqueTransporteurs = [];
    const seen = new Set();

    for (const transporteur of transporteurs) {
      const key = `${transporteur.transporteurName}-${transporteur.transporteurContact}-${transporteur.transporteurId}`;
      if (!seen.has(key)) {
        seen.add(key);
        uniqueTransporteurs.push({
          name: transporteur.transporteurName,
          contact: transporteur.transporteurContact,
          id: Number(transporteur.transporteurId),
        });
      }
    }
    return uniqueTransporteurs;
  }

  useEffect(() => {
    // Charger les données du produit et les données de référence
    Promise.all([
      axios.get(`${BackendUrl}/api/productsRoutes/${id}`),
      axios.get(`${BackendUrl}/api/categoriesRoutes`),
    ])
      .then(([productRes, categoriesRes]) => {
        const product = productRes.data.data;

        // Mettre à jour les images actuelles
        setCurrentImages({
          image1: product.image1,
          image2: product.image2,
          image3: product.image3,
        });
        setCurrentAdditionalImages(product.pictures || []);

        // Convertir les variantes existantes au nouveau format

        const convertedVariants =
          product.variants?.map((variant) => ({
            id: variant._id,
            color: variant.colorCode,
            colorName: variant.color,
            sizes: variant.sizes,
            imageUrl: variant.imageUrl,
            stock: variant.stock || 1,
            hasCustomPrice: variant.hasCustomPrice || false,
            price: variant.price || 0,
            isOnPromo: variant.isOnPromo || false,
            promoPrice: variant.promoPrice || 0,
            _id: variant._id,
          })) || [];
        setVariants(convertedVariants);
        // console.log(product);
        ////////////////////////////////////// details sur la livrason
        if (product?.shipping) {
          setShippingOptions(product?.shipping?.zones);
          setZones(
            product?.shipping?.zones?.map((param, index) => {
              return {
                name: param.name,
                code: "NM",
                id: index,
              };
            })
          );
        }

        ////////////////////////////////////// details sur la livrason

        setTransporteurs(extractUniqueTransporteurs(product?.shipping?.zones));
        setPackageDimensions({
          weight: product?.shipping?.weight,
          // length: product?.shipping?.dimensions?.length,
          // width: product?.shipping?.dimensions?.width,
          // height: product?.shipping?.dimensions?.height,
        });

        setSelectedOriginZone(product?.shipping?.origine);

        // Mettre à jour les données du produit
        setProductData({
          name: product.name,
          description: product.description,
          price: product.prix.toString(),
          pricePromo: product.prixPromo.toString(),
          quantity: product.quantite.toString(),
          brand: product.marque,
          supplier: product.Clefournisseur,
          type: product.ClefType,
        });
        setClefCategorie(product.ClefCategorie);

        // console.log(product);

        // Mettre à jour les données de référence
        setCategories(categoriesRes.data.data);
      })
      .catch((error) => {
        toast.error("Erreur lors du chargement des données");
        console.error(error);
      });
  }, [id]);

  // Fonction de validation
  function validateTransporteurs(transporteurs) {
    if (!Array.isArray(transporteurs) || transporteurs.length === 0) {
      handleAlertwar("Le tableau est vide ou invalide.");
      return false;
    }

    const requiredFields = [
      "name",
      "baseFee",
      // "weightFee",
      "transporteurContact",
      "transporteurId",
      "transporteurName",
    ];

    for (let i = 0; i < transporteurs.length; i++) {
      const transporteur = transporteurs[i];

      // Vérification des champs requis
      for (const field of requiredFields) {
        if (!(field in transporteur)) {
          handleAlertwar(`Champ manquant: ${field} à l'index ${i + 1}`);
          return false;
        }
      }

      // Vérification des types de données
      if (
        typeof transporteur.name !== "string" ||
        transporteur.name.trim() === ""
      ) {
        handleAlertwar(`Nom invalide à l'index ${i + 1}.`);
        return false;
      }
      if (
        typeof String(transporteur.transporteurContact) !== "string" ||
        !/^[0-9]{8}$/.test(String(transporteur.transporteurContact))
      ) {
        handleAlertwar(`Contact du transporteur invalide à l'index ${i + 1}.`);
        console.log(transporteur.transporteurContact);
        return false;
      }
      if (
        typeof Number(transporteur.transporteurId) !== "number" ||
        Number(transporteur.transporteurId) <= 0
      ) {
        handleAlertwar(`ID du transporteur invalide à l'index ${i + 1}.`);
        console.log(transporteur.transporteurId);
        return false;
      }
      if (
        typeof transporteur.baseFee !== "number" ||
        transporteur.baseFee < 0
      ) {
        handleAlertwar(`Frais de base invalide à l'index ${i + 1}.`);
        return false;
      }
      if (
        typeof transporteur.weightFee !== "number" ||
        transporteur.weightFee < 0
      ) {
        handleAlertwar(`Frais par Killo invalide à l'index ${i + 1}.`);
        return false;
      }
      if (
        typeof transporteur.transporteurName !== "string" ||
        transporteur.transporteurName.trim() === ""
      ) {
        handleAlertwar(`Nom du transporteur invalide à l'index ${i + 1}.`);
        return false;
      }
    }

    handleAlert("Validation réussie.");
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(deletedVariantIds);

    const errorMessages = {
      image1: "Vous devez mettre l'image1",
      image2: "Vous devez mettre l'image2",
      image3: "Vous devez mettre l'image3",
      colors: "Vous devez mettre au moins une couleur du produit",
      tails: "Vous devez mettre au moins une taille du produit",
      descriptionLength: "La description doit comporter au moins 20 caractères",
      priceInvalid: "Le prix est incorrect",
      quantityInvalid: "La quantité n'est pas valide",
      categorieInvalid: "La catégorie n'est pas valide",

      // Messages pour les dimensions du produit
      weightInvalid: "Le poids du produit doit être supérieur à 0",
      lengthInvalid: "La longueur du produit doit être supérieure à 0",
      widthInvalid: "La largeur du produit doit être supérieure à 0",
      heightInvalid: "La hauteur du produit doit être supérieure à 0",
      zoneInvalid: "vous deviez mettre au moins une option de livrason",
      origineInvalid: "vous deviez choisir votre zone d'origine ",
    };
    const regexNumber = /^\d+(\.\d+)?$/;

    if (productData.description.length <= 20) {
      console.log(productData.description);
      handleAlertwar(errorMessages.descriptionLength);
      return;
    }

    // Valider les images
    const imagesValid = productImagesRef.current.validateBeforeSubmit();

    if (!imagesValid) {
      handleAlertwar("veuillez mettre au moins une image principal");
      return;
    }

    if (!regexNumber.test(productData.price) || Number(productData.price) < 0) {
      handleAlertwar(errorMessages.priceInvalid);
      return;
    }

    if (
      !regexNumber.test(String(productData.quantity)) ||
      Number(productData.quantity) <= 0
    ) {
      handleAlertwar(errorMessages.quantityInvalid);
      return;
    }

    if (packageDimensions.weight === 0) {
      handleAlertwar(errorMessages.weightInvalid);
      return;
    }
    // if (packageDimensions.length === 0) {
    //   handleAlertwar(errorMessages.lengthInvalid);
    //   return;
    // }
    // if (packageDimensions.width === 0) {
    //   handleAlertwar(errorMessages.widthInvalid);
    //   return;
    // }
    // if (packageDimensions.height === 0) {
    //   handleAlertwar(errorMessages.heightInvalid);
    //   return;
    // }
    // if (shippingOptions?.length === 0) {
    //   handleAlertwar(errorMessages.zoneInvalid);
    //   return;
    // }
    if (selectedOriginZone?.length === 0 || selectedOriginZone === "choisir") {
      handleAlertwar(errorMessages.origineInvalid);
      return;
    }

    if (!ClefCategorie) {
      handleAlertwar(errorMessages.categorieInvalid);
      return;
    }

    // if (validateTransporteurs(shippingOptions)) {
    //   // handleAlert("Prêt pour l'envoi au backend.");
    // } else {
    //   handleAlertwar("Erreur de validation.");
    //   return;
    // }

    try {
      const formData = new FormData();

      // Ajouter les images principales modifiées
      Object.entries(mainImages).forEach(([key, file]) => {
        if (file) formData.append(key, file);
      });

      // Ajouter la liste des images à supprimer 1
      if (imagesToDelete.length > 0) {
        formData.append("imagesToDelete", JSON.stringify(imagesToDelete));
      }

      // // Ajouter les images additionnelles
      // additionalImages.forEach((file) => {
      //   formData.append("nouveauChampImages", file);
      // });

      // Ajouter les images des variantes
      variants.forEach((variant, index) => {
        if (variant.imageFile) {
          // Utiliser le nom de la couleur comme clé pour l'upload
          formData.append(`imageVariante${index}`, variant.imageFile);
        }
      });
      formData.append("name", productData.name);
      formData.append("shippingZones", JSON.stringify(shippingOptions));
      formData.append("origine", selectedOriginZone);
      formData.append("weight", packageDimensions.weight);
      // formData.append("length", packageDimensions.length);
      // formData.append("width", packageDimensions.width);
      // formData.append("height", packageDimensions.height);
      formData.append("prix", productData.price);
      formData.append("ClefCategorie", ClefCategorie);
      formData.append("description", productData.description);
      formData.append("quantite", productData.quantity);
      formData.append("prixPromo", productData.pricePromo);
      formData.append("ClefType", ClefType);
      formData.append("Clefournisseur", Clefournisseur);
      formData.append("sellerOrAdmin", "seller");
      formData.append("sellerOrAdmin_id", admin?.id);
      formData.append("deletedVariantIds", JSON.stringify(deletedVariantIds));
      formData.append(
        "marque",
        productData.brand.length != 0 ? productData.brand : "inconu"
      );

      // Ajouter les variantes (sans les fichiers d'image)
      const variantsToSend = variants?.map(
        ({ imageFile, imagePreview, ...rest }) => rest
      );
      formData.append("variants", JSON.stringify(variantsToSend));

      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}:`, value);
      // }

      setIsLoading(true);
      const response = await axios.put(
        `${BackendUrl}/api/productsRoutes/update/${id}`,
        formData
      );
      toast.success(response.data.message);
      setDeletedVariantIds([]);
      const response2 = await axios.get(
        `${BackendUrl}/api/productsRoutes/${id}`
      );
      const product = response2.data.data;

      // Mettre à jour les images actuelles
      setCurrentImages({
        image1: product.image1,
        image2: product.image2,
        image3: product.image3,
      });
      setCurrentAdditionalImages(product.pictures || []);

      // Convertir les variantes existantes au nouveau format

      const convertedVariants =
        product.variants?.map((variant) => ({
          id: variant._id,
          color: variant.colorCode,
          colorName: variant.color,
          sizes: variant.sizes,
          imageUrl: variant.imageUrl,
          stock: variant.stock || 1,
          hasCustomPrice: variant.hasCustomPrice || false,
          price: variant.price || 0,
          isOnPromo: variant.isOnPromo || false,
          promoPrice: variant.promoPrice || 0,
          _id: variant._id,
        })) || [];
      setVariants(convertedVariants);
      // console.log(product.variants);

      // Mettre à jour les données du produit
      setProductData({
        name: product.name,
        description: product.description,
        price: product.prix.toString(),
        pricePromo: product.prixPromo.toString(),
        quantity: product.quantite.toString(),
        brand: product.marque,
        supplier: product.Clefournisseur,
        type: product.ClefType,
      });
      setClefournisseur(product.Clefournisseur);
      setClefType(product.ClefType);
      // window.location.reload();

      // navigate(`/Admin/ProductDet/${id}`);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Erreur lors de la mise à jour du produit"
      );
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour mettre à jour les images à supprimer (utilisée par le composant ProductImages) 1
  const updateImagesToDelete = (images) => {
    setImagesToDelete(images);
  };

  // Fonction pour afficher les toasts
  const showToast = ({ type, message }) => {
    switch (type) {
      case "success":
        toast.success(message);
        break;
      case "error":
        toast.error(message);
        break;
      case "warning":
        toast.warning(message);
        break;
      default:
        toast.info(message);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8 flex items-center justify-between">
          <h1 className="text-3xl font-bold text-gray-900">
            Modifier le Produit
          </h1>
          <button
            onClick={() => window.history.back()}
            className="flex items-center px-4 py-2 text-sm text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour
          </button>
        </div>

        <form className="space-y-8">
          {/* Section des informations de base - Version modernisée */}
          <div className="bg-white shadow-lg rounded-xl p-6 md:p-8 border border-gray-100">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-blue-100 p-2 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-blue-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                Informations de base
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Nom du produit <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={productData.name}
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  required
                  placeholder="Entrez le nom du produit"
                />
              </div>

              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Prix <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span className="text-gray-500">€</span>
                  </div>
                  <input
                    type="number"
                    step="any"
                    value={productData.price}
                    onChange={(e) =>
                      setProductData((prev) => ({
                        ...prev,
                        price: e.target.value,
                      }))
                    }
                    className="w-full pl-8 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    required
                    min="0"
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Prix promotionnel
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span className="text-gray-500">€</span>
                  </div>
                  <input
                    type="number"
                    step="any"
                    value={productData.pricePromo}
                    onChange={(e) =>
                      setProductData((prev) => ({
                        ...prev,
                        pricePromo: e.target.value,
                      }))
                    }
                    className="w-full pl-8 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    min="0"
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Quantité <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  value={productData.quantity}
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      quantity: e.target.value,
                    }))
                  }
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  required
                  min="1"
                  placeholder="1"
                />
              </div>

              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Marque
                </label>
                <input
                  type="text"
                  value={productData.brand}
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      brand: e.target.value,
                    }))
                  }
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="Nom de la marque"
                />
              </div>

              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  {ClefCategorie
                    ? categories.find((item) => item?._id === ClefCategorie)
                        ?.name
                    : ""}
                </label>
                <div className="relative">
                  <select
                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all pr-10"
                    onChange={(e) => {
                      setClefCategorie(
                        categories[Number(e.target.selectedIndex) - 1]?._id
                      );
                    }}
                  >
                    <option>Choisir</option>
                    {categories ? (
                      categories?.map((param, index) => {
                        return <option key={index}>{param.name}</option>;
                      })
                    ) : (
                      <option>Aucun</option>
                    )}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="h-5 w-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Section des images */}
          {/* <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-6">Images du produit</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {["image1", "image2", "image3"].map((key, index) => (
                <div key={key} className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Image principale {index + 1}
                  </label>
                  <div className="flex items-center justify-center w-full">
                    <label className="w-full h-64 flex flex-col items-center justify-center border-2 border-dashed rounded-lg cursor-pointer hover:bg-gray-50">
                      {mainImages[key] ? (
                        <img
                          src={URL.createObjectURL(mainImages[key])}
                          alt={`Preview ${index + 1}`}
                          className="w-full h-full object-contain"
                        />
                      ) : currentImages[key] ? (
                        <img
                          src={currentImages[key]}
                          alt={`Current ${index + 1}`}
                          className="w-full h-full object-contain"
                        />
                      ) : (
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          <Upload className="w-8 h-8 text-gray-400" />
                          <p className="mt-2 text-sm text-gray-500">
                            Cliquez pour modifier
                          </p>
                        </div>
                      )}
                      <input
                        type="file"
                        className="hidden"
                        onChange={(e) => handleImageChange(e, key)}
                        accept="image/*"
                      />
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div> */}

          {/* Section des images */}
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-gray-900">
              Images du produit
            </h3>
            <ProductImages
              ref={productImagesRef}
              mainImages={mainImages}
              setMainImages={setMainImages}
              currentImages={currentImages}
              setCurrentImages={setCurrentImages}
              updateImagesToDelete={updateImagesToDelete}
              setImagesToDelete={setImagesToDelete}
              imagesToDelete={imagesToDelete}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              showToast={showToast}
            />
          </div>

          {/* Section de la description */}
          {/* <div className="bg-white shadow rounded-lg p-4 md:p-6 mb-6">
            <h2 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">
              Description
            </h2>

            <div className="editor-container relative">
              <div className="max-h-64 overflow-y-auto">
                <ReactQuill
                  value={productData.description}
                  onChange={(value) =>
                    setProductData((prev) => ({ ...prev, description: value }))
                  }
                  className="min-h-40"
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["link", "video"],
                      ["clean"],
                    ],
                  }}
                  formats={[
                    "header",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "list",
                    "bullet",
                    "link",
                    "video",
                  ]}
                />
              </div>
              <div className="mt-2 mb-6 text-xs text-gray-500">
                Faites défiler pour voir tout le contenu
              </div>
            </div>
          </div> */}

          <div className="bg-white shadow-lg rounded-xl p-6 md:p-8 border border-gray-100 mb-6">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-indigo-100 p-2 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-indigo-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                Description
              </h2>
            </div>

            <div className="editor-container relative rounded-lg border border-gray-200 overflow-hidden">
              <div className="max-h-64 overflow-y-auto bg-white">
                <ReactQuill
                  value={productData.description}
                  onChange={(value) =>
                    setProductData((prev) => ({ ...prev, description: value }))
                  }
                  className="min-h-40 [&*.ql-toolbar]:border-t-0 [&*.ql-toolbar]:border-x-0 [&*.ql-toolbar]:border-b [&*.ql-toolbar]:border-gray-200 [&*.ql-toolbar]:bg-gray-50 [&*.ql-editor]:min-h-[150px] [&_.ql-editor]:p-4"
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["link", "video"],
                      ["clean"],
                    ],
                  }}
                  formats={[
                    "header",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "list",
                    "bullet",
                    "link",
                    "video",
                  ]}
                />
              </div>
              <div className="flex items-center py-2 px-4 bg-gray-50 border-t border-gray-200">
                <div className="text-xs text-gray-500 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 mr-1 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                  Faites défiler pour voir tout le contenu
                </div>
                <div className="ml-auto text-xs text-gray-500">
                  {productData.description ? (
                    <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-full">
                      {productData.description.replace(/<[^>]*>/g, "").length}{" "}
                      caractères
                    </span>
                  ) : (
                    <span>0 caractères</span>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-4 text-sm text-gray-600">
              <p>
                Décrivez votre produit en détail pour aider vos clients à
                comprendre ses caractéristiques et avantages.
              </p>
            </div>
          </div>

          {/* Section des variantes */}
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-6">Variantes du produit</h2>
            <ProductVariantForm
              chg={chgDeletedVariantIds}
              variants={variants}
              setVariants={setVariants}
              defaultPrice={productData.price}
              defaultPromoPrice={productData.pricePromo}
              isEditMode={true}
            />
          </div>

          <ShippingRatesManager
            selectedOriginZone={selectedOriginZone}
            setSelectedOriginZone={setSelectedOriginZone}
            nouvelleZone={nouvelleZone}
            setNouvelleZone={setNouvelleZone}
            zones={zones}
            setZones={setZones}
            nouveauTransporteur={nouveauTransporteur}
            setNouveauTransporteur={setNouveauTransporteur}
            transporteurs={transporteurs}
            setTransporteurs={setTransporteurs}
            shippingOptions={shippingOptions}
            setShippingOptions={setShippingOptions}
            produitId={id}
            packageDimensions={packageDimensions}
            setPackageDimensions={setPackageDimensions}
          />

          {/* Boutons d'action */}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={() => window.history.back()}
              className="px-6 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Annuler
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={isLoading}
              className="px-6 py-3 text-sm font-medium text-white bg-blue-600 rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-400"
            >
              {isLoading ? "Mise à jour en cours..." : "Mettre à jour"}
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}
